// extracted by mini-css-extract-plugin
export var label = "_b0-1";
export var reminder = "_b0-0";